import React, { useState } from "react";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import { ListarTipoRelacaoClienteController } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoRelacaoCliente/TipoRelacaoClienteControllers";
import LazySelect from "../../../Forms/LazySelect";
import {
    ListarContatoNaoVinculadoController,
    VincularContaContatoController,
} from "../../../../../Controllers/Geral/Contatos/ContaContato/ContatoContatoControllers";
import SearchSelect from "../../../Forms/SearchSelect";

interface IVincularContaContatoProps {
    setShow: (show: boolean) => void;
    update: () => void;
    idConta: number;
}
interface IVincularContatoFormData {
    IDRelacaoCliente: number;
}

export default function VincularContaContato(
    props: IVincularContaContatoProps
) {
    const { register, handleSubmit } = useForm<IVincularContatoFormData>();

    const [idContato, setIdContato] = useState<number>();

    function handleVincularContatoFormSubmit(
        formData: IVincularContatoFormData
    ) {
        if (idContato) {
            VincularContaContatoController({
                ID_CONTA: props.idConta,
                ID_CONTATO: idContato,
                ID_CONTA_CONTATO: 0,
                ID_TIPO_RELACAO_CLIENTE: formData.IDRelacaoCliente,
            }).then(() => {
                props.setShow(false);
                props.update();
            });
        }
    }

    return (
        <form
            className="w-100 align-itens-center mt-5 m-0"
            onSubmit={handleSubmit(handleVincularContatoFormSubmit)}
        >
            <div className="form-group row">
                <div className="col-12 mt-2">
                    <label>Contato: *</label>
                    {/* <Select
                        showSearch
                        value={idContato}
                        onChange={setIdContato}
                        defaultActiveFirstOption={false}
                        showArrow
                        className="ant-select-custom-input w-100"
                        filterOption={false}
                        onSearch={handleSearch}
                        notFoundContent={null}
                        >
                        {
                            lstContatos?.map( c => <Select.Option key={`${c.ID_CONTATO}`} value={c.ID_CONTATO}>{c.DS_NOME}</Select.Option> )
                        }
                    </Select> */}
                    <SearchSelect
                        controller={(searchValue: string) =>
                            ListarContatoNaoVinculadoController(
                                searchValue,
                                props.idConta
                            )
                        }
                        getDS={(contato) => contato.DS_NOME}
                        getKeyValue={(contato) => contato.ID_CONTATO}
                        onChange={(idContato) =>
                            setIdContato(idContato as number)
                        }
                        value={idContato}
                    />
                </div>
            </div>

            <div className="form-group row">
                <div className="col-12 mt-2">
                    <label>Tipo de Relação com Cliente:</label>
                    <LazySelect
                        controller={ListarTipoRelacaoClienteController}
                        getDS={(trc) => trc.DS_TIPO_RELACAO_CLIENTE}
                        getKeyValue={(trc) => trc.TIPO_RELACAO_CLIENTE}
                        name="IDRelacaoCliente"
                        placeholder={"Digite o número do telefone:"}
                        className={`form-control px-0 p-2 placeholder-muted-75`}
                        ref={register({
                            required: "Insira o Tipo Relação Cliente",
                        })}
                    />
                </div>
            </div>

            <button className="btn btn-success w-100 mt-5">
                <FontAwesomeIcon icon={faPlus} className="mr-2" /> Vincular
            </button>
        </form>
    );
}
